import React from 'react';

import axios from 'axios'; 

import Modal from 'react-bootstrap/Modal';

class _Modal extends React.Component{
    constructor(props){
        super(props);

        //this.hideModal = this.hideModal.bind(this);

        this.onSubmit = this.onSubmit.bind(this);

        this.state = {
            showModal:false,
            loaded:false,
          }
    }
    onSubmit(e){

        e.preventDefault();
    
        const formData = new FormData();
    
        var fields = ['name','email','phone','job','industry','service','country'];
    
        for (let i = 0; i < fields.length; i++) {
    
          console.log(fields[i]);
    
          if(document.querySelector('input[name="'+fields[i]+'"],select[name="'+fields[i]+'"]').value){
            formData.append( 
              fields[i], 
              document.querySelector('input[name="'+fields[i]+'"],select[name="'+fields[i]+'"]').value
            ); 
          }
        }
        if(document.querySelector('textarea[name="comments"]').value){
          formData.append( 
            'comments', 
            document.querySelector('textarea[name="comments"]').value
          ); 
        }
    
        var that = this;

        this.setState({showModal:true});

        axios.post("https://mailer.weprodigi.com/api/v1/offer-react", formData).then(response => {

          that.setState({loaded:true});

          that.props.callBack();

        });
      }
    render(){
        //console.log(this.props.service)
        return(
            <Modal size="lg" show={this.props.show} onHide={this.props.hide} centered className="offer">

            <span className="hide" onClick={this.props.hide}>X</span>
                
                <Modal.Body>

                        <span className="title">get offer for</span>
                        <span className="service">{this.props.service}</span>

                        <form type="POST" id="form" encType="multipart/form-data" onSubmit={this.onSubmit}>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="form-group">
                                        <label>Your Name*</label>
                                        <input type="text" name="name" id="get-offer-name" className="form-control" required></input>
                                    </div>
                                    <div className="form-group">
                                        <label>Email*</label>
                                        <input type="email" name="email" id="get-offer-email" className="form-control" required></input>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    
                                    <div className="form-group" style={{display:(window.innerWidth < 1000 ? 'block': 'none')}}>
                                        <label>Job Position</label>
                                        <select name="job" className="form-control">
                                            <option value="" disabled selected hidden>Please Select</option>
                                            <option value="CEO/C-Level / VP">CEO/C-Level / VP</option>
                                            <option value="Marketing Manager / Marketing Director">Marketing Manager / Marketing Director</option>
                                            <option value="Operations Manager">Operations Manager</option>
                                            <option value="Financial Manager">Financial Manager</option>
                                            <option value="Production Manager">Production Manager</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                    <div className="form-group">
                                        <label>Phone Number</label>
                                        <input type="text" name="phone" className="form-control"></input>
                                    </div>
                                    <div className="form-group">
                                        <label>Industry</label>
                                        <select name="industry" className="form-control">
                                            <option value="" disabled selected hidden>Please Select</option>
                                            <option value="Operations Manager">Operations Manager</option>
                                            <option value="Accounting and Finance">Accounting and Finance</option>
                                            <option value="Construction">Construction</option>
                                            <option value="Creative and Design">Creative and Design</option>
                                            <option value="Customer Service">Customer Service</option>
                                            <option value="Education">Education</option>
                                            <option value="Energy and Utilities">Energy and Utilities</option>
                                            <option value="Engineering">Engineering</option>
                                            <option value="Financial Services">Financial Services</option>
                                            <option value="Healthcare">Healthcare</option>
                                            <option value="IT">IT</option>
                                            <option value="Legal">Legal</option>
                                            <option value="Marketing and Advertising">Marketing and Advertising</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group">
                                        <label>Comments</label>
                                        <textarea name="comments" rows="6" className="form-control"></textarea>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12">
                                    <div className="form-group">
                                    <button type="submit" form="form" className="button" id="offer-submit" href="#">Submit</button>
                                    </div>
                                </div>
                            </div>
                            <input type="hidden" name="service" value={this.props.service}></input>
                            <input type="hidden" name="country" value={this.props.country}></input>
                            
                        </form>

                    </Modal.Body>
            </Modal>
        );
    }
}

export default _Modal;